import React from 'react';
import PropTypes from 'prop-types';
import UnitItemListContainer from './UnitItemListContainer';
import Card from '../../../../../core/layout/Card';
import Breadcrumb from '../../../../../core/layout/Breadcrumb';
import Separator from '../../../../../core/layout/Separator';
import UnitGrammarsFormContainer from './UnitGrammarsFormContainer';
import CreateUnitItemDraftDialogContainer from './CreateUnitItemDraftDialogContainer';
import UnitItemListActionsContainer from './UnitItemListActionsContainer';
import MoveUnitItemFormDialogContainer from './MoveUnitItemFormDialogContainer';

const UnitItemListScene = (props) => (
  <div>
    <Breadcrumb
      fetching={props.fetching}
      crumbs={[
        {
          text: `Course - ${props.module.course.name}`,
          link: '/modules',
        },
        {
          text: `Module - ${props.module.name}`,
          link: `/modules/${props.module.id}/details`,
        },
        {
          text: `Unit - ${props.unit.name}`,
          link: `/modules/${props.module.id}/units/${props.unit.id}`,
        },
        {
          text: 'Unit items',
        },
      ]}
    />
    <Card title="Grammars">
      {props.unit.id && props.module.id && (
        <UnitGrammarsFormContainer unitId={props.unit.id} moduleId={props.module.id} />
      )}
    </Card>
    <Separator />
    <Card
      title="Items"
      loading={props.fetching}
      actions={<UnitItemListActionsContainer course={props.module.course} module={props.module} unit={props.unit} />}
    >
      {props.unit.id ? (
        <>
          <UnitItemListContainer unit={props.unit} />
          <MoveUnitItemFormDialogContainer />
          <CreateUnitItemDraftDialogContainer module={props.module} unit={props.unit} />
        </>
      ) : (
        <div />
      )}
    </Card>
  </div>
);

UnitItemListScene.propTypes = {
  unit: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    createdBy: PropTypes.string,
    module: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
  module: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    course: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  fetching: PropTypes.bool,
};

UnitItemListScene.defaultProps = {
  unit: {
    module: {},
  },
  module: {
    course: {},
  },
  fetching: false,
};

export default UnitItemListScene;
